import React, { ReactChild } from 'react';

const IcCardOnDelivery = ({ fill }): ReactChild => {
  const mainFill = fill || '#000';

  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1 3.4H4.9V20.6H16.1V3.4ZM3.5 2V22H17.5V19H21.5V9H17.5V2H3.5ZM20.1 17.6H17.5V10.4H20.1V17.6ZM6.5 5V12H14.5V5H6.5ZM13.1 6.4H7.9V10.6H13.1V6.4ZM6.5 14V16H8.5V14H6.5ZM8.5 17H6.5V19H8.5V17ZM9.5 14V16H11.5V14H9.5ZM11.5 17H9.5V19H11.5V17ZM12.5 14V16H14.5V14H12.5ZM14.5 17H12.5V19H14.5V17Z"
        fill={mainFill}
        fillOpacity="0.75"
      />
    </svg>
  );
};

export default IcCardOnDelivery;
